/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Expand",
  size: 20
}

const SvgExpand = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M13 2h5v5h-1V3h-4zM2 13h1v4h4v1H2z" />
    <path fill="none" strokeWidth={1.1} d="M11 9l6-6M3 17l6-6" />
  </Svg>
)

SvgExpand.defaultProps = defaultProps
export default SvgExpand
